"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotaryOperationApiCodes = exports.FolderSharingApiCodes = exports.THIRD_PARTY_CREATE_OFFICE_EMAIL_CONFLICT_CODES = exports.OfficeEmailIdentityApiCodes = exports.ThirdPartyApiCodes = void 0;
exports.ThirdPartyApiCodes = {
    EMAIL_REQUIRED: "THIRD_PARTY_EMAIL_REQUIRED",
    CONTACT_UID_NOT_FOUND: "THIRD_PARTY_CONTACT_UID_NOT_FOUND",
    CONTACT_UID_EMAIL_MISMATCH: "THIRD_PARTY_CONTACT_UID_EMAIL_MISMATCH",
    DUPLICATE_IN_FOLDER_OFFICE: "THIRD_PARTY_DUPLICATE_IN_FOLDER_OFFICE",
};
exports.OfficeEmailIdentityApiCodes = {
    CUSTOMER_DUPLICATE: "OFFICE_EMAIL_CUSTOMER_DUPLICATE",
    CUSTOMER_BLOCKED_BY_THIRD_PARTY: "OFFICE_EMAIL_CUSTOMER_BLOCKED_BY_THIRD_PARTY",
    THIRD_PARTY_BLOCKED_BY_CUSTOMER: "OFFICE_EMAIL_THIRD_PARTY_BLOCKED_BY_CUSTOMER",
    THIRD_PARTY_BLOCKED_BY_OTHER_FOLDER: "OFFICE_EMAIL_THIRD_PARTY_BLOCKED_BY_OTHER_FOLDER",
    FOLDER_SHARING_INVITED_EMAIL_OFFICE_CONFLICT: "OFFICE_EMAIL_FOLDER_SHARING_INVITED_EMAIL_CONFLICT",
};
exports.THIRD_PARTY_CREATE_OFFICE_EMAIL_CONFLICT_CODES = [
    exports.OfficeEmailIdentityApiCodes.THIRD_PARTY_BLOCKED_BY_CUSTOMER,
];
exports.FolderSharingApiCodes = {
    DUPLICATE_ACTIVE_SHARE: "FOLDER_SHARING_DUPLICATE_ACTIVE",
    SELF_INVITE_NOT_ALLOWED: "FOLDER_SHARING_SELF_INVITE_NOT_ALLOWED",
    SAME_OFFICE_INVITE_NOT_ALLOWED: "FOLDER_SHARING_SAME_OFFICE_INVITE_NOT_ALLOWED",
    TEMPORARY_INVITED_OFFICE_CREATE_FAILED: "FOLDER_SHARING_TEMPORARY_INVITED_OFFICE_CREATE_FAILED",
    INVITED_OFFICE_IDNOT_REQUIRED: "FOLDER_SHARING_INVITED_OFFICE_IDNOT_REQUIRED",
    INVITED_OFFICE_ANNUAIRE_UNRESOLVED: "FOLDER_SHARING_INVITED_OFFICE_ANNUAIRE_UNRESOLVED",
    INVITED_OFFICE_PROVISION_FAILED: "FOLDER_SHARING_INVITED_OFFICE_PROVISION_FAILED",
    INVITED_NOTARY_IDNOT_INCOHERENT: "FOLDER_SHARING_INVITED_NOTARY_IDNOT_INCOHERENT",
    INVITED_NOTARY_IDNOT_UNRESOLVED: "FOLDER_SHARING_INVITED_NOTARY_IDNOT_UNRESOLVED",
};
exports.NotaryOperationApiCodes = {
    REMINDERS_AUTOMATIC_DISABLED: "NOTARY_REMINDERS_AUTOMATIC_DISABLED",
    DOCUMENTS_NOTARY_BATCH_NO_FILES: "NOTARY_DOCUMENTS_NOTARY_BATCH_NO_FILES",
    DOCUMENTS_NOTARY_BATCH_NO_RECIPIENTS: "NOTARY_DOCUMENTS_NOTARY_BATCH_NO_RECIPIENTS",
    DOCUMENTS_NOTARY_BATCH_NO_VALID_DOCUMENTS: "NOTARY_DOCUMENTS_NOTARY_BATCH_NO_VALID_DOCUMENTS",
    ANCHOR_ABANDONED_CERTIFICATE: "NOTARY_ANCHOR_ABANDONED_CERTIFICATE",
};
